import React, { useRef, useEffect, useState, useCallback } from 'react';
import './QuatrePortes.css';
import LogoBlanc from '../components/LogoBlanc';
import Atlas from './Atlas';

const DOORS = [
  { id:1, numeral:'I',   artist:'Participant·e 1', title:'Titre de l\'œuvre', desc:'Description courte.', color:'#e8a832', colorRgb:'232,168,50',   audioSrc:'/media/APA/LyreBird.mp3', bgImage: null  },
  { id:2, numeral:'II',  artist:'Participant·e 2', title:'Titre de l\'œuvre', desc:'Description courte.', color:'#9b59e8', colorRgb:'155,89,232',  audioSrc:'/media/APA/Gaspard_BehindTheSky.mp3', bgImage:'/media/APA/Gaspard_2.png'  },
  { id:3, numeral:'III', artist:'Participant·e 3', title:'Titre de l\'œuvre', desc:'Description courte.', color:'#e87d5a', colorRgb:'232,125,90',  audioSrc:'/media/APA/Mix_Leonie.mp3', bgImage:'/media/APA/fondLeonie.png'  },
  { id:4, numeral:'IV',  artist:'Participant·e 4', title:'Titre de l\'œuvre', desc:'Description courte.', color:'#c47fd4', colorRgb:'196,127,212',  audioSrc: null, bgImage: null },
];

// ── Porte ────────────────────────────────────────────────────────
const Door = ({ door, isOpen, isHidden, wrapOpacity, panelOpacity, onClick, animDelay, onRef, texture, frontTexOpacity = 1 }) => (
  <div
    ref={onRef}
    className={`qp-door-wrap${isOpen ? ' qp-door-wrap--open' : ''}${isHidden ? ' qp-door-wrap--hidden' : ''}`}
    style={{ '--door-color': door.color, '--door-rgb': door.colorRgb, '--lev-delay': `${animDelay}s`, '--mov-delay': `${animDelay * 0.7}s`, opacity: wrapOpacity !== undefined ? wrapOpacity : undefined }}
    onClick={onClick}
  >
    <svg className="qp-door-svg" viewBox="0 0 160 420" fill="none" preserveAspectRatio="none">
      <rect x="1" y="1" width="158" height="418" stroke={door.color} strokeWidth="0.5" opacity="0.45"/>
      <rect x="12" y="18" width="136" height="384" stroke={door.color} strokeWidth="0.3" opacity="0.2"/>
      <line x1="1" y1="18" x2="159" y2="18" stroke={door.color} strokeWidth="0.5" opacity="0.4"/>
      <line x1="1" y1="419" x2="159" y2="419" stroke={door.color} strokeWidth="1" opacity="0.55"/>
      <circle cx="80" cy="90" r="1.5" fill={door.color} opacity="0.35"/>
      <line x1="14" y1="20" x2="80" y2="90" stroke={door.color} strokeWidth="0.18" opacity="0.14"/>
      <line x1="146" y1="20" x2="80" y2="90" stroke={door.color} strokeWidth="0.18" opacity="0.14"/>
      <line x1="14" y1="398" x2="80" y2="90" stroke={door.color} strokeWidth="0.18" opacity="0.14"/>
      <line x1="146" y1="398" x2="80" y2="90" stroke={door.color} strokeWidth="0.18" opacity="0.14"/>
    </svg>
    <div
      className={`qp-door-panel${door.id === 3 ? ' qp-door-panel--textured' : ''}`}
      style={{
        opacity: panelOpacity !== undefined ? panelOpacity : 1,
        backgroundImage: door.id === 3 ? 'url(/media/APA/modele_porte_470_1080.jpg)' : undefined,
        backgroundSize: door.id === 3 ? 'cover' : undefined,
        backgroundPosition: door.id === 3 ? 'center' : undefined,
        background: texture && door.id !== 3 ? 'none' : undefined,
        transformOrigin: door.id === 2 ? 'right center' : 'left center',
        transform: isOpen
          ? door.id === 2
            ? 'perspective(900px) rotateY(110deg)'
            : 'perspective(900px) rotateY(-110deg)'
          : undefined,
      }}
    >
      {/* Face arrière (intérieur porte) */}
{door.id === 3
        ? <div className="qp-door-panel-back qp-door-panel-back--3" style={{
            backgroundImage: 'url(/media/APA/modele_porte_470_1080.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }} />
        : <div className={`qp-door-panel-back qp-door-panel-back--${door.id}`} />
      }
      {/* Face avant (extérieur porte) — texture si définie, sinon transparent */}
      {texture && (
        <div className="qp-door-panel-front" style={{
          position: 'absolute', inset: 0,
          backgroundImage: `url(${texture})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          zIndex: 2,
          backfaceVisibility: 'hidden',
          WebkitBackfaceVisibility: 'hidden',
          opacity: frontTexOpacity,
          transition: 'opacity 1s ease',
        }} />
      )}
      {door.id !== 3 && <div className={`qp-door-handle${door.id === 2 ? ' qp-door-handle--left' : ''}`} />}
    </div>

  </div>
);

// ── Composant principal ───────────────────────────────────────────


// ── Mini-portes salle 4 ───────────────────────────────────────
// Contenues dans le cadre MouseZoneBackground : top:100px left:60px right:60px bottom:60px
// Positionnées en % de ce cadre, sans superposition, formes variées
const MINI_DOORS_DATA = [
  { l: 76.5, t:  7.6, w: 7, h:34, ci:3, dl:1.2 },
  { l: 45.6, t: 57.0, w: 9, h:33, ci:0, dl:1.1 },
  { l: 52.3, t: 18.5, w: 5, h:29, ci:3, dl:0.3 },
  { l: 63.4, t: 63.1, w: 9, h:30, ci:0, dl:0.1 },
  { l:  8.5, t: 31.8, w:10, h:31, ci:0, dl:1.2 },
  { l: 77.8, t: 57.9, w: 6, h:25, ci:3, dl:1.0 },
  { l: 23.0, t: 30.2, w:10, h:40, ci:3, dl:0.1 },
  { l: 63.3, t: 37.8, w: 5, h:19, ci:3, dl:1.3 },
  { l:  4.8, t: 66.8, w: 5, h:23, ci:3, dl:1.3 },
  { l: 93.4, t: 23.3, w: 6, h:24, ci:2, dl:0.4 },
  { l: 86.1, t: 30.2, w: 5, h:19, ci:2, dl:0.8 },
  { l: 16.2, t: 69.1, w: 5, h:29, ci:3, dl:0.3 },
  { l: 40.5, t:  7.6, w: 5, h:20, ci:1, dl:0.7 },
  { l: 36.6, t: 58.5, w: 5, h:25, ci:0, dl:1.2 },
  { l: 89.5, t: 54.4, w: 7, h:35, ci:3, dl:1.2 },
  { l:  8.5, t:  0.0, w: 5, h:26, ci:2, dl:0.4 },
  { l: 59.7, t: 12.9, w: 7, h:18, ci:1, dl:1.0 },
  { l: 27.7, t: 74.1, w: 6, h:25, ci:2, dl:0.4 },
  { l:  1.9, t:  4.3, w: 5, h:25, ci:0, dl:0.7 },
];

const DOOR4_COLORS = ['#5ab4e8', '#7ec8f0', '#4a9fd4', '#aee0ff'];

const MiniDoor = ({ l, t, w, h, ci, dl, index, isOpen, onClick }) => {
  const color = DOOR4_COLORS[ci];
  return (
    <div
      onClick={onClick}
      onMouseEnter={e => { e.currentTarget.style.filter = `drop-shadow(0 0 8px ${color}aa)`; }}
      onMouseLeave={e => { e.currentTarget.style.filter = 'none'; }}
      style={{
        position: 'absolute',
        left: `${l}%`, top: `${t}%`,
        width: `${w}%`, height: `${h}%`,
        cursor: 'pointer',
        animation: `qp-levitation ${5.5 + (index % 4) * 0.9}s ease-in-out infinite, qp-movement ${7.5 + (index % 5) * 0.8}s ease-in-out infinite`,
        animationDelay: `${dl}s, ${dl * 0.6}s`,
      }}
    >
      {/* Cadre SVG — pointer-events:none pour ne pas bloquer le clic */}
      <svg viewBox="0 0 160 420" fill="none" width="100%" height="100%"
        preserveAspectRatio="none"
        style={{ position:'absolute', inset:0, zIndex:2, pointerEvents:'none' }}>
        <rect x="1" y="1" width="158" height="418" stroke={color} strokeWidth="1.2" opacity="0.7"/>
        <rect x="12" y="18" width="136" height="384" stroke={color} strokeWidth="0.6" opacity="0.3"/>
        <line x1="1" y1="18" x2="159" y2="18" stroke={color} strokeWidth="1" opacity="0.6"/>
        <line x1="1" y1="419" x2="159" y2="419" stroke={color} strokeWidth="1.5" opacity="0.7"/>
        <circle cx="80" cy="90" r="2" fill={color} opacity="0.5"/>
        <line x1="14" y1="20" x2="80" y2="90" stroke={color} strokeWidth="0.4" opacity="0.25"/>
        <line x1="146" y1="20" x2="80" y2="90" stroke={color} strokeWidth="0.4" opacity="0.25"/>
        <line x1="14" y1="398" x2="80" y2="90" stroke={color} strokeWidth="0.4" opacity="0.25"/>
        <line x1="146" y1="398" x2="80" y2="90" stroke={color} strokeWidth="0.4" opacity="0.25"/>
      </svg>
      {/* Battant — pointer-events:none */}
      <div style={{
        position: 'absolute',
        top: '4%', left: '7.5%',
        width: '85%', height: '92%',
        background: 'linear-gradient(135deg, rgba(7,3,26,0.96), rgba(14,9,41,0.98))',
        transformOrigin: 'left center',
        transform: isOpen ? 'perspective(600px) rotateY(-100deg)' : 'none',
        transition: 'transform 1.4s cubic-bezier(0.76, 0, 0.24, 1)',
        zIndex: 3,
        pointerEvents: 'none',
      }}>
        <div style={{
          position: 'absolute', right: '11%', top: '50%',
          transform: 'translateY(-50%)',
          width: '6%', height: '8%',
          background: `${color}44`,
          border: `0.5px solid ${color}66`,
          borderRadius: '1px',
        }} />
      </div>
    </div>
  );
};


// ── Fonction utilitaire : dessine fondNassim avec extension des bords ──
const drawNassimCanvas = (el) => {
  if (!el) return;
  const img = new Image();
  img.crossOrigin = 'anonymous';
  img.onload = () => {
    el.width  = el.offsetWidth  || window.innerWidth;
    el.height = el.offsetHeight || window.innerHeight;
    const ctx = el.getContext('2d');
    // Désactiver l'interpolation pour éviter l'antialiasing sur les colonnes 1px
    ctx.imageSmoothingEnabled = false;

    const W = el.width, H = el.height;
    const imgRatio = img.width / img.height;
    const imgH = H;
    const imgW = imgH * imgRatio;
    const imgX = Math.floor((W - imgW) / 2);

    // Dessiner l'image complète dans un canvas temporaire à sa taille réelle
    const tmp = document.createElement('canvas');
    tmp.width = img.width; tmp.height = img.height;
    const tctx = tmp.getContext('2d');
    tctx.imageSmoothingEnabled = false;
    tctx.drawImage(img, 0, 0);

    // Lire les pixels de la colonne gauche (x=0) et droite (x=img.width-1)
    const leftCol  = tctx.getImageData(0,              0, 1, img.height);
    const rightCol = tctx.getImageData(img.width - 1,  0, 1, img.height);

    // Créer deux canvas 1px pour les colonnes gauche et droite
    const cLeft = document.createElement('canvas');
    cLeft.width = 1; cLeft.height = img.height;
    cLeft.getContext('2d').putImageData(leftCol, 0, 0);

    const cRight = document.createElement('canvas');
    cRight.width = 1; cRight.height = img.height;
    cRight.getContext('2d').putImageData(rightCol, 0, 0);

    // Bande gauche — étirer la colonne gauche
    ctx.imageSmoothingEnabled = false;
    for (let x = 0; x < imgX; x++)
      ctx.drawImage(cLeft, 0, 0, 1, img.height, x, 0, 1, H);

    // Image centrale
    ctx.drawImage(img, imgX, 0, imgW, imgH);

    // Bande droite — étirer la colonne droite (pixels exacts, sans antialiasing)
    for (let x = Math.ceil(imgX + imgW); x < W; x++)
      ctx.drawImage(cRight, 0, 0, 1, img.height, x, 0, 1, H);
  };
  img.src = '/media/APA/fondNassim2.png';
};

const QuatrePortes = () => {
  // Porte ouverte/en fermeture
  const [openDoorId,    setOpenDoorId]    = useState(null);
  const [closingDoorId, setClosingDoorId] = useState(null);
  // Contrôle rotation battant (indépendant de openDoorId)
  const [isPanelOpen,   setIsPanelOpen]   = useState(false);
  // Opacités
  const [bgClipOpacity, setBgClipOpacity] = useState(0);
  const [bgFullOpacity, setBgFullOpacity] = useState(0);
  const [panelOpacity,  setPanelOpacity]  = useState(1);
  const [wrapOpacity,   setWrapOpacity]   = useState(1);
  // Rect du panneau pour clip-path
  const [panelRect, setPanelRect]       = useState(null);
  const [bgClipFast, setBgClipFast]     = useState(false);
  const [frontTexOpacity, setFrontTexOpacity] = useState(1);
  const [bgImageIndex, setBgImageIndex]   = useState(0);
  const [introStep, setIntroStep]         = useState(0);
  const [introVisible, setIntroVisible]   = useState(false);
  const [cassetteReady, setCassetteReady] = useState(false);
  const [creatureOpacity, setCreatureOpacity] = useState(0);
  const [specimenOpen, setSpecimenOpen]     = useState(false);
  const [openMiniDoors, setOpenMiniDoors]   = useState(new Set());
  const [infosOpen, setInfosOpen]           = useState(false);
  const [showAtlas, setShowAtlas]           = useState(false);
  const [atlasVisible, setAtlasVisible]     = useState(false);
  const [room4Stage, setRoom4Stage]         = useState(0); // 0=vestibule, 1=mini-portes
  const [centerDoorOpen, setCenterDoorOpen] = useState(false);
  const [room4Transition, setRoom4Transition] = useState(false); // fade entre vestibule et mini-portes
  const [playerTime, setPlayerTime]       = useState(0);
  const [playerDuration, setPlayerDuration] = useState(0);
  const playerRafRef = useRef(null);
  const playerBarRef     = useRef(null);
  const playerTimeRef    = useRef(null);
  const cassetteBarRef   = useRef(null);
  // Contenu salle
  const [roomVisible, setRoomVisible] = useState(false);

  const audioRef   = useRef(null);
  const doorRefs    = useRef({});       // ← refs des wrappers de porte
  const timersRef   = useRef([]);
  const trackRafRef  = useRef(null);      // ← RAF de tracking de la porte
  const bgClipRef    = useRef(null);       // ← ref direct sur le div bg-clipped
  const bgClip2Ref   = useRef(null);       // ← second div clippé creature1 salle 1
  const activeDoorAudioRef = useRef(null);
  const introEndedRef = useRef(false); // ← empêche double déclenchement fin intro
  const bgVideoRef   = useRef(null);       // ← vidéo de fond salle 2
  const pinkNoiseRef  = useRef(null);
  const miniAudioRefs = useRef({});

  const activeDoor = DOORS.find(d => d.id === (openDoorId ?? closingDoorId)) || null;

  // ── Tracking continu de la position du panneau ───────────────
  const startTracking = useCallback((doorId) => {
    const update = () => {
      const el = doorRefs.current[doorId];
      if (!el) { trackRafRef.current = requestAnimationFrame(update); return; }
      const wr = el.getBoundingClientRect();
      const top    = wr.top    + wr.height * 0.04;
      const left   = wr.left   + wr.width  * 0.075;
      const width  = wr.width  * 0.85;
      const height = wr.height * 0.92;
      const right  = window.innerWidth  - left - width;
      const bottom = window.innerHeight - top  - height;
      // Mise à jour directe sur le DOM — zéro délai React
      if (bgClipRef.current) {
        const cp = `inset(${top}px ${right}px ${bottom}px ${left}px)`;
        bgClipRef.current.style.clipPath = cp;
        if (bgClip2Ref.current) bgClip2Ref.current.style.clipPath = cp;
      }
      // Garder panelRect en sync pour le premier rendu
      setPanelRect({ top, left, width, height });
      trackRafRef.current = requestAnimationFrame(update);
    };
    trackRafRef.current = requestAnimationFrame(update);
  }, []);

  const stopTracking = useCallback(() => {
    if (trackRafRef.current) {
      cancelAnimationFrame(trackRafRef.current);
      trackRafRef.current = null;
    }
  }, []);

  // ── Timers ────────────────────────────────────────────────────
  const later = useCallback((fn, ms) => {
    const id = setTimeout(fn, ms);
    timersRef.current.push(id);
  }, []);
  const clearTimers = useCallback(() => {
    timersRef.current.forEach(clearTimeout);
    timersRef.current = [];
    stopTracking();
  }, [stopTracking]);


  const fmt = (s) =>
    `${Math.floor((s||0)/60).toString().padStart(2,'0')}:${Math.floor((s||0)%60).toString().padStart(2,'0')}`;

  // ── Vidéo de fond salle 2 ─────────────────────────────────
  useEffect(() => {
    if (openDoorId !== 2) return;
    // Attendre que les éléments vidéo soient montés
    const t = setTimeout(() => {
      if (bgVideoRef.current) {
        bgVideoRef.current.volume = 0.8;
        bgVideoRef.current.play().catch(() => {});
      }
    }, 200);
    return () => clearTimeout(t);
  }, [openDoorId]);

  // RAF du lecteur piloté par la vidéo de fond pour la porte 2
  useEffect(() => {
    if (openDoorId !== 2) return;
    if (playerRafRef.current) cancelAnimationFrame(playerRafRef.current);
    const updateFromVideo = () => {
      const v = bgVideoRef.current;
      if (!v || !v.duration) {
        playerRafRef.current = requestAnimationFrame(updateFromVideo);
        return;
      }
      if (playerBarRef.current)
        playerBarRef.current.style.width = `${(v.currentTime / v.duration) * 100}%`;
      if (playerTimeRef.current)
        playerTimeRef.current.textContent = fmt(v.currentTime) + ' / ' + fmt(v.duration);
      playerRafRef.current = requestAnimationFrame(updateFromVideo);
    };
    playerRafRef.current = requestAnimationFrame(updateFromVideo);
    return () => { if (playerRafRef.current) cancelAnimationFrame(playerRafRef.current); };
  }, [openDoorId, fmt]);


  // ── Bruit rose salle 4 ──────────────────────────────────────
  const startPinkNoise = useCallback(() => {
    if (pinkNoiseRef.current) return;
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const bufferSize = 4096;
    const node = ctx.createScriptProcessor(bufferSize, 0, 1);
    let b0=0,b1=0,b2=0,b3=0,b4=0,b5=0,b6=0;
    node.onaudioprocess = (e) => {
      const out = e.outputBuffer.getChannelData(0);
      for (let i = 0; i < bufferSize; i++) {
        const w = Math.random()*2-1;
        b0=0.99886*b0+w*0.0555179; b1=0.99332*b1+w*0.0750759;
        b2=0.96900*b2+w*0.1538520; b3=0.86650*b3+w*0.3104856;
        b4=0.55000*b4+w*0.5329522; b5=-0.7616*b5-w*0.0168980;
        out[i]=(b0+b1+b2+b3+b4+b5+b6+w*0.5362)*0.11; b6=w*0.115926;
      }
    };
    const gainNode = ctx.createGain();
    gainNode.gain.setValueAtTime(0.0001, ctx.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(0.06, ctx.currentTime + 3);
    const filter = ctx.createBiquadFilter();
    filter.type = 'bandpass'; filter.frequency.value = 800; filter.Q.value = 0.8;
    const convolver = ctx.createConvolver();
    const rLen = ctx.sampleRate * 3;
    const rBuf = ctx.createBuffer(2, rLen, ctx.sampleRate);
    for (let ch = 0; ch < 2; ch++) {
      const d = rBuf.getChannelData(ch);
      for (let i = 0; i < rLen; i++) d[i]=(Math.random()*2-1)*Math.pow(1-i/rLen,2.5);
    }
    convolver.buffer = rBuf;
    const dryGain = ctx.createGain(); dryGain.gain.value = 0.6;
    const wetGain = ctx.createGain(); wetGain.gain.value = 0.4;
    node.connect(filter);
    filter.connect(dryGain); filter.connect(convolver); convolver.connect(wetGain);
    dryGain.connect(gainNode); wetGain.connect(gainNode); gainNode.connect(ctx.destination);
    const volInt = setInterval(() => {
      if (!pinkNoiseRef.current) { clearInterval(volInt); return; }
      const {gainNode:g,ctx:c}=pinkNoiseRef.current;
      const t=0.04+Math.random()*0.05, dur=4+Math.random()*7;
      g.gain.cancelScheduledValues(c.currentTime); g.gain.setValueAtTime(g.gain.value,c.currentTime);
      g.gain.exponentialRampToValueAtTime(Math.max(t,0.001),c.currentTime+dur);
    }, 5000);
    const pitchInt = setInterval(() => {
      if (!pinkNoiseRef.current) { clearInterval(pitchInt); return; }
      const {filter:f,ctx:c}=pinkNoiseRef.current;
      f.frequency.setTargetAtTime(200+Math.random()*1800,c.currentTime,(1.5+Math.random()*4)*0.25);
      f.Q.setTargetAtTime(0.4+Math.random()*1.2,c.currentTime,(1.5+Math.random()*4)*0.25);
    }, 2500);
    const reverbInt = setInterval(() => {
      if (!pinkNoiseRef.current) { clearInterval(reverbInt); return; }
      const {wetGain:w,dryGain:dr,ctx:c}=pinkNoiseRef.current;
      const wet=0.2+Math.random()*0.7, dur=3+Math.random()*6;
      w.gain.setTargetAtTime(wet,c.currentTime,dur*0.3);
      dr.gain.setTargetAtTime(1-wet*0.6,c.currentTime,dur*0.3);
    }, 4000);
    pinkNoiseRef.current={ctx,gainNode,filter,node,wetGain,dryGain,volInt,pitchInt,reverbInt};
  }, []);

  const stopPinkNoise = useCallback(() => {
    if (!pinkNoiseRef.current) return;
    const {ctx,gainNode,volInt,pitchInt,reverbInt}=pinkNoiseRef.current;
    clearInterval(volInt); clearInterval(pitchInt); clearInterval(reverbInt);
    gainNode.gain.cancelScheduledValues(ctx.currentTime);
    gainNode.gain.setValueAtTime(gainNode.gain.value,ctx.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(0.0001,ctx.currentTime+2.5);
    setTimeout(()=>{try{ctx.close();}catch(e){}},2600);
    pinkNoiseRef.current=null;
  }, []);

  // ── Audio mini-portes salle 4 (mode dorien) ──────────────────
  const MINI_DOOR_FREQS = [73.4,87.3,98.0,110.0,130.8,146.8,164.8,174.6,196.0,
    220.0,246.9,261.6,293.7,329.6,349.2,392.0,440.0,523.3,587.3];

  const startMiniDoorAudio = useCallback((index) => {
    if (miniAudioRefs.current[index]) return;
    const freq = MINI_DOOR_FREQS[index % MINI_DOOR_FREQS.length];
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const osc = ctx.createOscillator(); osc.type='sine'; osc.frequency.value=freq;
    const osc2 = ctx.createOscillator(); osc2.type='sine'; osc2.frequency.value=freq*1.003;
    const gainNode = ctx.createGain();
    gainNode.gain.setValueAtTime(0.0001,ctx.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(0.022,ctx.currentTime+1.5);
    const gain2 = ctx.createGain(); gain2.gain.value=0.5;
    const convolver = ctx.createConvolver();
    const rLen=ctx.sampleRate*2.5; const rBuf=ctx.createBuffer(2,rLen,ctx.sampleRate);
    for(let ch=0;ch<2;ch++){const d=rBuf.getChannelData(ch);for(let i=0;i<rLen;i++)d[i]=(Math.random()*2-1)*Math.pow(1-i/rLen,2);}
    convolver.buffer=rBuf;
    const wetGain=ctx.createGain(); wetGain.gain.value=0.5;
    const dryGain=ctx.createGain(); dryGain.gain.value=0.5;
    osc.connect(gainNode); osc2.connect(gain2); gain2.connect(gainNode);
    gainNode.connect(dryGain); gainNode.connect(convolver);
    convolver.connect(wetGain); dryGain.connect(ctx.destination); wetGain.connect(ctx.destination);
    osc.start(); osc2.start();
    const volInt=setInterval(()=>{
      if(!miniAudioRefs.current[index]){clearInterval(volInt);return;}
      const{gainNode:g,ctx:c}=miniAudioRefs.current[index];
      const t=0.012+Math.random()*0.015,dur=2+Math.random()*5;
      g.gain.cancelScheduledValues(c.currentTime);g.gain.setValueAtTime(g.gain.value,c.currentTime);
      g.gain.exponentialRampToValueAtTime(Math.max(t,0.001),c.currentTime+dur);
    },3000+Math.random()*2000);
    const pitchInt=setInterval(()=>{
      if(!miniAudioRefs.current[index]){clearInterval(pitchInt);return;}
      const{osc:o,osc2:o2,ctx:c}=miniAudioRefs.current[index];
      const drift=1+(Math.random()-0.5)*0.008,dur=2+Math.random()*4;
      o.frequency.setTargetAtTime(freq*drift,c.currentTime,dur*0.3);
      o2.frequency.setTargetAtTime(freq*1.003*drift,c.currentTime,dur*0.3);
    },2500+Math.random()*2000);
    const reverbInt=setInterval(()=>{
      if(!miniAudioRefs.current[index]){clearInterval(reverbInt);return;}
      const{wetGain:w,dryGain:dr,ctx:c}=miniAudioRefs.current[index];
      const wet=0.3+Math.random()*0.5,dur=3+Math.random()*5;
      w.gain.setTargetAtTime(wet,c.currentTime,dur*0.3);
      dr.gain.setTargetAtTime(1-wet*0.5,c.currentTime,dur*0.3);
    },4000+Math.random()*3000);
    miniAudioRefs.current[index]={ctx,osc,osc2,gainNode,wetGain,dryGain,volInt,pitchInt,reverbInt};
  }, []);

  const stopMiniDoorAudio = useCallback((index) => {
    const a=miniAudioRefs.current[index]; if(!a) return;
    clearInterval(a.volInt); clearInterval(a.pitchInt); clearInterval(a.reverbInt);
    a.gainNode.gain.cancelScheduledValues(a.ctx.currentTime);
    a.gainNode.gain.setValueAtTime(a.gainNode.gain.value,a.ctx.currentTime);
    a.gainNode.gain.exponentialRampToValueAtTime(0.0001,a.ctx.currentTime+1);
    setTimeout(()=>{try{a.ctx.close();}catch(e){}},1100);
    delete miniAudioRefs.current[index];
  }, []);

  const stopAllMiniDoorAudio = useCallback(() => {
    Object.keys(miniAudioRefs.current).forEach(i=>stopMiniDoorAudio(Number(i)));
  }, [stopMiniDoorAudio]);


  // ── Canvas particules ─────────────────────────────────────────
  useEffect(() => {
    const cv = document.getElementById('qp-bg-canvas');
    if (!cv) return;
    let animId;
    const resize = () => { cv.width = window.innerWidth; cv.height = window.innerHeight; };
    resize();
    window.addEventListener('resize', resize);
    const ctx = cv.getContext('2d');
    const pts = Array.from({ length: 50 }, () => ({
      x: Math.random()*cv.width, y: Math.random()*cv.height,
      r: Math.random()*1+0.3, vx:(Math.random()-.5)*.1, vy:(Math.random()-.5)*.1,
      a: Math.random()*.3+.04,
    }));
    const draw = () => {
      ctx.clearRect(0,0,cv.width,cv.height);
      pts.forEach(p => {
        p.x+=p.vx; p.y+=p.vy;
        if(p.x<0)p.x=cv.width; if(p.x>cv.width)p.x=0;
        if(p.y<0)p.y=cv.height; if(p.y>cv.height)p.y=0;
        ctx.beginPath(); ctx.arc(p.x,p.y,p.r,0,Math.PI*2);
        ctx.fillStyle=`rgba(240,237,230,${p.a})`; ctx.fill();
      });
      pts.forEach((a,i)=>pts.slice(i+1).forEach(b=>{
        const d=Math.hypot(a.x-b.x,a.y-b.y);
        if(d<110){ctx.beginPath();ctx.moveTo(a.x,a.y);ctx.lineTo(b.x,b.y);
          ctx.strokeStyle=`rgba(240,237,230,${.03*(1-d/110)})`;ctx.lineWidth=.3;ctx.stroke();}
      }));
      animId=requestAnimationFrame(draw);
    };
    draw();
    return () => { cancelAnimationFrame(animId); window.removeEventListener('resize',resize); };
  }, []);

  // ── Audio ─────────────────────────────────────────────────────
  const stopAudio = useCallback((onDone) => {
    if (!audioRef.current) { onDone?.(); return; }
    const a = audioRef.current; audioRef.current = null;
    let v = a.volume;
    const fade = setInterval(() => {
      v=Math.max(v-.04,0); a.volume=v;
      if(v<=0){ a.pause(); clearInterval(fade); onDone?.(); }
    }, 40);
  }, []);

  const playAudio = useCallback((src) => {
    if (!src) return;
    const a = new Audio(src); a.loop=true; a.volume=0;
    a.play().catch(()=>{});
    audioRef.current = a;
    let v=0;
    const fade=setInterval(()=>{
      v=Math.min(v+.02,.8);
      if(audioRef.current) audioRef.current.volume=v;
      if(v>=.8) clearInterval(fade);
    },60);
  }, []);

  // ── Fin d'intro ──────────────────────────────────────────────
  const endIntro = useCallback(() => {
    if (introEndedRef.current) return;
    introEndedRef.current = true;
    setIntroVisible(false);
    setTimeout(() => { setCassetteReady(true); setCreatureOpacity(1); }, 500);
    setTimeout(() => {
      if (activeDoorAudioRef.current) playAudio(activeDoorAudioRef.current);
    }, 1500);
  }, [playAudio]);

  // ── Avance l'intro au clic ───────────────────────────────────
  const advanceIntro = useCallback(() => {
    setIntroStep(prev => {
      if (prev < 4) return prev + 1;
      if (prev === 4) setTimeout(endIntro, 0);
      return prev;
    });
  }, [endIntro]);

  // ── OUVERTURE ─────────────────────────────────────────────────
  const enterDoor = useCallback((door) => {
    if (openDoorId || closingDoorId) return;

    // Tracking continu de la position du panneau (suit la lévitation)
    startTracking(door.id);

    // Reset
    setBgClipOpacity(0);
    setBgFullOpacity(0);
    setPanelOpacity(1);
    setBgClipFast(false);
    setBgImageIndex(0);
    setFrontTexOpacity(1);
    setWrapOpacity(1);
    setRoomVisible(false);

    setOpenDoorId(door.id);
    setIsPanelOpen(true);

    if (door.id === 2) {
      // Porte 2 : audio vient de la vidéo
    } else if (door.id === 1) {
      // Porte 1 : texte intro d'abord, puis cassette + audio
      activeDoorAudioRef.current = door.audioSrc;
      introEndedRef.current = false;
      // Texte intro : démarre 1s après roomVisible (roomVisible à t=2200ms)
      // Double RAF pour garantir que le DOM est peint avant la transition
      later(() => {
        setIntroVisible(true);
        requestAnimationFrame(() =>
          requestAnimationFrame(() => setIntroStep(1))
        );
      }, 3200);
      later(() => requestAnimationFrame(() =>
        requestAnimationFrame(() => setIntroStep(2))
      ), 7200);
      later(() => requestAnimationFrame(() =>
        requestAnimationFrame(() => setIntroStep(3))
      ), 10200);
      later(() => requestAnimationFrame(() =>
        requestAnimationFrame(() => setIntroStep(4))
      ), 15200);
      // Disparition + audio
      later(() => endIntro(), 22200);
    } else if (door.audioSrc) {
      if (door.id === 3) {
        // Salle 3 : démarrage différé + fondu lent (0→0.8 en ~6s)
        later(() => {
          if (!door.audioSrc) return;
          const a = new Audio(door.audioSrc); a.loop=true; a.volume=0;
          a.play().catch(()=>{});
          audioRef.current = a;
          let v = 0;
          const fade = setInterval(() => {
            v = Math.min(v + 0.008, 0.8);
            if (audioRef.current) audioRef.current.volume = v;
            if (v >= 0.8) clearInterval(fade);
          }, 60);
        }, 2000);
      } else {
        playAudio(door.audioSrc);
      }
    }

    // RAF lecteur — pas pour la porte 2 (géré par updateFromVideo)
    if (door.id !== 2) {
      if (playerRafRef.current) cancelAnimationFrame(playerRafRef.current);
      const updatePlayer = () => {
        const a = audioRef.current;
        // Toujours relancer même si audio pas encore chargé
        if (a && a.duration) {
          const t = a.currentTime;
          const pct = t / a.duration;
          if (cassetteBarRef.current) {
            const w = pct * 108;
            cassetteBarRef.current.setAttribute('width', String(w));
            const cursor = cassetteBarRef.current.parentNode?.querySelector('.qp-cassette__cursor');
            if (cursor) cursor.setAttribute('cx', String(56 + w));
          }
          if (playerBarRef.current)
            playerBarRef.current.style.width = `${pct * 100}%`;
          if (playerTimeRef.current)
            playerTimeRef.current.textContent = fmt(t) + ' / ' + fmt(a.duration);
        }
        playerRafRef.current = requestAnimationFrame(updatePlayer);
      };
      playerRafRef.current = requestAnimationFrame(updatePlayer);
    }


    // t=500ms   bg clippé fade in — dès que la porte commence à s'ouvrir
    later(() => setBgClipOpacity(1), 500);

    // t=2000ms  bg full fade in (2s)
    later(() => setBgFullOpacity(1), 2000);
    // t=3000ms  bg clippé disparaît
    later(() => setBgClipOpacity(0), 3000);
    // t=4500ms  wrapper porte disparaît — après que le battant soit complètement ouvert
    later(() => setWrapOpacity(0), 4500);

    // t=2000ms  texture recto portes 1 et 2 : fade out
    if (door.id === 2) later(() => setFrontTexOpacity(0), 2000);
    if (door.id === 1) later(() => setFrontTexOpacity(0), 2000);
    // t=3000ms  battant fade out (1s)
    later(() => setPanelOpacity(0), 3000);

    // t=2200ms  texte/contenu
    later(() => setRoomVisible(true), 2200);
    if (door.id === 4) later(() => startPinkNoise(), 2200);

  }, [openDoorId, closingDoorId, playAudio, later, startTracking, stopTracking]);

  // ── FERMETURE (miroir exact) ──────────────────────────────────
  const exitRoom = useCallback(() => {
    clearTimers();
    setRoomVisible(false);
    stopAudio();
    stopPinkNoise();
    stopAllMiniDoorAudio();
    setIntroStep(0);
    introEndedRef.current = false;
    setIntroVisible(false);
    setCassetteReady(false);
    setCreatureOpacity(0);
    setSpecimenOpen(false);
    setOpenMiniDoors(new Set());
    stopAllMiniDoorAudio();
    setRoom4Stage(0);
    setCenterDoorOpen(false);
    setRoom4Transition(false);
    if (bgVideoRef.current) { bgVideoRef.current.pause(); bgVideoRef.current.currentTime = 0; }
    if (playerRafRef.current) { cancelAnimationFrame(playerRafRef.current); playerRafRef.current = null; }
    setBgImageIndex(0);
    // Texture recto : porte 2 à t=2000ms, porte 1 à t=3500ms (1.5s plus tard)
    if (openDoorId === 2) later(() => setFrontTexOpacity(1), 2000);
    if (openDoorId === 1) later(() => setFrontTexOpacity(1), 2500);

    // MIROIR :
    // Ouverture : isPanelOpen=true(2s) | bgClip↑(2s) | bgFull↑(2s) | panel↓(1s)
    // Fermeture : panel↑(1s) | bgFull↓(2s) | isPanelOpen=false(2s) | bgClip↓(2s)

    // t=0       bg full fade OUT (2s). bg clippé remis à 1 — fond visible dans l'encadrure.
    setBgFullOpacity(0);
    setBgClipOpacity(1);
    setBgClipFast(false);
    setWrapOpacity(1);

    // t=1000ms  battant fade IN (1s) — toujours ouvert
    later(() => setPanelOpacity(1), 1000);

    // t=2000ms  battant se referme (rotation 2s). bg clippé toujours visible.
    // tracking déjà actif depuis enterDoor — pas besoin de le relancer
    later(() => {
      const id = openDoorId;
      setIsPanelOpen(false);
      setClosingDoorId(id);
      setOpenDoorId(null);
    }, 2000);

    // t=3000ms  bg clippé fade OUT rapide (0.6s). Autres portes apparaissent.
    later(() => { setBgClipFast(true); setBgClipOpacity(0); }, 3000);

    // t=4200ms  nettoyage + arrêt tracking
    later(() => {
      stopTracking();
      setBgClipFast(false);
      setClosingDoorId(null);
      setPanelRect(null);
    }, 4200);

  }, [stopAudio, openDoorId, clearTimers, later, startTracking, stopTracking]);

  // Touche Échap
  useEffect(() => {
    const onKey = e => { if (e.key==='Escape' && (openDoorId||closingDoorId)) exitRoom(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [openDoorId, closingDoorId, exitRoom]);


  return (
    <>
      <LogoBlanc />
      {/* Titre visible uniquement sur la page d'accueil */}
      {!openDoorId && !closingDoorId && <h1 className={`qp-page-title${infosOpen ? ' qp-page-title--blurred' : ''}`}>
        {'Fiction & Mondes multiples'.split('').map((char, i) => (
          <span
            key={i}
            className="qp-page-title__char"
            style={{ animationDelay: `${(i * 0.17 + Math.random() * 0.5).toFixed(2)}s` }}
          >
            {char === ' ' ? ' ' : char}
          </span>
        ))}
      </h1>}

      {/* Bouton infos — visible uniquement sur la page d'accueil */}
      {!openDoorId && !closingDoorId && !atlasVisible && <button className="qp-btn-infos" onClick={() => setInfosOpen(o => !o)}>infos</button>}
      {!openDoorId && !closingDoorId && !atlasVisible && (
        <button className="qp-btn-atlas" onClick={() => {
          setShowAtlas(true);
          requestAnimationFrame(() => requestAnimationFrame(() => setAtlasVisible(true)));
        }}>
          <span>ATLAS</span>
          <svg viewBox="0 0 40 60" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="24">
            <polygon points="8,8 32,30 8,52" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
          </svg>
        </button>
      )}

      {/* <h1 style={{
        position:'fixed', top:'2.7rem', right:'60px',
        fontFamily:"'Source Sans 3', sans-serif", fontSize:'clamp(2.5rem,4vw,3rem)',
        fontWeight:300, color:'rgba(255,255,255,0.55)', letterSpacing:'0.2rem',
        textAlign:'right', textTransform:'uppercase',
        margin:0, pointerEvents:'none', zIndex:1000, lineHeight:1,
      }}>Quatre Portes</h1> */}

      {/* 1 — Bg clippé à l'encadrure — clipPath mis à jour directement via ref */}
      {activeDoor && panelRect && (
        activeDoor.id === 2 ? (
          <div
            ref={bgClipRef}
            className={`qp-bg-clipped${bgClipFast ? ' qp-bg-clipped--fast-out' : ''}`}
            style={{
              backgroundImage: `url('/media/APA/behind the sky phase 2.bmp')`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              opacity: bgClipOpacity,
            }}
          />
        ) : activeDoor.id === 4 ? (
          <canvas
            ref={el => { bgClipRef.current = el; drawNassimCanvas(el); }}
            className={`qp-bg-clipped${bgClipFast ? ' qp-bg-clipped--fast-out' : ''}`}
            style={{ opacity: bgClipOpacity, width:'100%', height:'100%' }}
          />
        ) : (
          <div
            ref={bgClipRef}
            className={`qp-bg-clipped${bgClipFast ? ' qp-bg-clipped--fast-out' : ''}`}
            style={{
              backgroundImage: activeDoor.id === 1
                ? `url(/media/APA/fond_josephine.jpg)`
                : activeDoor.bgImage ? `url(${activeDoor.bgImage})` : 'none',
              backgroundSize: activeDoor.id === 1 ? '100% 100%' : 'cover',
              opacity: bgClipOpacity,
            }}
          />
        )
      )}

      {/* 1b — creature1 clippé à l'encadrure — visible seulement si creatureOpacity > 0 */}
      {activeDoor?.id === 1 && panelRect && creatureOpacity > 0 && (
        <div
          ref={bgClip2Ref}
          className={`qp-bg-clipped${bgClipFast ? ' qp-bg-clipped--fast-out' : ''}`}
          style={{
            backgroundImage: `url(/media/APA/creature1.jpg)`,
            backgroundSize: 'auto 90vh',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            opacity: bgClipOpacity * creatureOpacity,
            transition: 'opacity 1s ease',
            zIndex: 7,
          }}
        />
      )}

      {/* 2 — Bg plein écran */}
      {activeDoor && (<>
        {activeDoor.id === 2 ? (
          <video
            ref={bgVideoRef}
            className="qp-bg-video"
            src="/media/APA/BehindTheSkyFINAL.mp4"
            playsInline loop
            style={{ opacity: bgFullOpacity, transition: 'opacity 2s ease' }}
          />
        ) : (
          <div className="qp-bg-full" style={{
            backgroundImage: `url(${activeDoor.bgImage})`,
            opacity: bgFullOpacity,
          }} />
        )}
      </>)}

      {/* Scène */}
      <div className="qp-scene">
        <canvas id="qp-bg-canvas" className="qp-bg-canvas" />
        <div className="qp-doors-row">
          {DOORS.map((door, i) => (
            <Door
              key={door.id}
              door={door}
              isOpen={(openDoorId===door.id || closingDoorId===door.id) && isPanelOpen}
              isHidden={openDoorId!==null && openDoorId!==door.id && closingDoorId!==door.id}
              wrapOpacity={(openDoorId===door.id) ? wrapOpacity : undefined}
              panelOpacity={(openDoorId===door.id || closingDoorId===door.id) && door.id !== 4 ? panelOpacity : undefined}
              onClick={() => !(openDoorId||closingDoorId) && enterDoor(door)}
              animDelay={i * 0.5}
              texture={door.id === 3 ? '/media/APA/modele_porte_470_1080.jpg' : door.id === 2 ? '/media/APA/Gaspard_porte.png' : door.id === 1 ? '/media/APA/porte_josephine.jpg' : undefined}
              frontTexOpacity={(door.id === 2 || door.id === 1) ? frontTexOpacity : 1}
              onRef={el => { doorRefs.current[door.id] = el; }}
            />
          ))}
        </div>

      </div>

      {/* Contenu salle */}
      <div
        className={`qp-room${roomVisible ? ' qp-room--active' : ''}`}
        style={{
          '--room-color': activeDoor?.color,
          pointerEvents: activeDoor?.id === 4 ? 'none' : undefined,
        }}
      >
        <div className="qp-room-content">
        </div>
      </div>

      {/* ── Bouton sortir — gère les sous-étapes salle 4 ── */}
      {roomVisible && (
        <button
          className="qp-btn-exit"
          style={{ color: (activeDoor?.id === 1 || (activeDoor?.id === 4 && room4Stage === 0)) ? 'rgba(15,10,35,0.8)' : undefined }}
          onClick={activeDoor?.id === 4 && room4Stage === 1 ? () => {
              // Fermer toutes les mini-portes et stopper leurs sons progressivement
              setOpenMiniDoors(new Set());
              stopAllMiniDoorAudio();
              // Relancer le bruit rose de la salle 4
              startPinkNoise();
              // Transition visuelle
              setRoom4Transition(true);
              setTimeout(() => { setRoom4Stage(0); }, 700);
              setTimeout(() => { setRoom4Transition(false); setCenterDoorOpen(false); }, 900);
            } : exitRoom} aria-label="Sortir par la porte">
          <svg className="qp-exit-arrow" viewBox="0 0 200 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <polygon points="100,72 160,42 140,42 140,8 60,8 60,42 40,42" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
            <line x1="100" y1="72" x2="100" y2="42" stroke="currentColor" strokeWidth="0.5" opacity="0.4"/>
            <line x1="60"  y1="42" x2="100" y2="72" stroke="currentColor" strokeWidth="0.5" opacity="0.25"/>
            <line x1="140" y1="42" x2="100" y2="72" stroke="currentColor" strokeWidth="0.5" opacity="0.25"/>
            <line x1="60"  y1="8"  x2="100" y2="72" stroke="currentColor" strokeWidth="0.4" opacity="0.12"/>
            <line x1="140" y1="8"  x2="100" y2="72" stroke="currentColor" strokeWidth="0.4" opacity="0.12"/>
            <polygon points="60,8 140,8 140,42 60,42" fill="currentColor" opacity="0.06"/>
          </svg>
        </button>
      )}
      {/* ── Lecteur audio flottant ── */}
      {activeDoor && activeDoor.id !== 1 && activeDoor.id !== 4 && (
        <div className={`qp-player${roomVisible ? ' qp-player--visible' : ''}`}>

          <div
            className="qp-player__timeline"
            onClick={e => {
              const r = e.currentTarget.getBoundingClientRect();
              const ratio = (e.clientX - r.left) / r.width;
              if (activeDoor?.id === 2 && bgVideoRef.current) {
                bgVideoRef.current.currentTime = ratio * (bgVideoRef.current.duration || 0);
              } else {
                const a = audioRef.current;
                if (!a) return;
                a.currentTime = ratio * (a.duration || 0);
              }
            }}
          >
            <div className="qp-player__progress" ref={playerBarRef} />
            <div className="qp-player__handle" />
          </div>
          <div className="qp-player__info">
            <span ref={playerTimeRef} className="qp-player__time">00:00 / 00:00</span>
          </div>
        </div>
      )}

      {/* ── Fond josephine salle 1 — toujours visible, strech ── */}
      {activeDoor?.id === 1 && (
        <div
          className="qp-bg-full"
          style={{
            backgroundImage: `url(/media/APA/fond_josephine.jpg)`,
            backgroundSize: '100% 100%',
            backgroundRepeat: 'no-repeat',
            opacity: bgFullOpacity,
            zIndex: 4,
          }}
        />
      )}

      {/* ── creature1.jpg — apparaît avec la cassette ── */}
      {activeDoor?.id === 1 && (
        <div
          className="qp-bg-full"
          style={{
            backgroundImage: `url(/media/APA/creature1.jpg)`,
            backgroundSize: 'auto 90vh',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            opacity: creatureOpacity,
            transition: 'opacity 2s ease',
            zIndex: 5,
          }}
        />
      )}

      {/* ── Salle 4 : vestibule Nassim ── */}
      {activeDoor?.id === 4 && room4Stage === 0 && (
        <div className="qp-room4-vestibule" style={{ opacity: room4Transition ? 0 : bgFullOpacity, transition: 'opacity 0.7s ease' }}>
          {/* Fond Nassim : canvas pour étirer les pixels des bords */}
          <canvas
            ref={el => {
              if (!el) return;
              const img = new Image();
              img.crossOrigin = 'anonymous';
              img.onload = () => {
                const ctx = el.getContext('2d');
                el.width = el.offsetWidth;
                el.height = el.offsetHeight;
                const W = el.width, H = el.height;
                // Hauteur de l'image centrée (contain)
                const imgRatio = img.width / img.height;
                const imgH = H;
                const imgW = imgH * imgRatio;
                const imgX = (W - imgW) / 2;
                // Bande gauche : étirer le pixel de gauche de l'image
                const leftPx = ctx.createImageData(1, H);
                const tmpLeft = document.createElement('canvas');
                tmpLeft.width = img.width; tmpLeft.height = img.height;
                tmpLeft.getContext('2d').drawImage(img, 0, 0);
                const col = tmpLeft.getContext('2d').getImageData(0, 0, 1, img.height);
                // Étirer la colonne gauche sur toute la bande gauche
                for (let x = 0; x < imgX; x++) {
                  ctx.drawImage(tmpLeft, 0, 0, 1, img.height, x, 0, 1, H);
                }
                // Image centrale
                ctx.drawImage(img, imgX, 0, imgW, imgH);
                // Bande droite : étirer le pixel de droite
                for (let x = imgX + imgW; x < W; x++) {
                  ctx.drawImage(tmpLeft, img.width - 1, 0, 1, img.height, x, 0, 1, H);
                }
              };
              img.src = '/media/APA/fondNassim2.png';
            }}
            style={{ position:'absolute', inset:0, width:'100%', height:'100%' }}
          />
          {/* Petite porte centrale cliquable */}
          <div
            className="qp-room4-door-center"
            onClick={() => {
              if (!centerDoorOpen) {
                setCenterDoorOpen(true);
                setTimeout(() => stopPinkNoise(), 800);
                // Fade out vestibule à 1200ms, puis mini-portes
                setTimeout(() => setRoom4Transition(true), 1200);
                setTimeout(() => { setRoom4Stage(1); setRoom4Transition(false); }, 1900);
              }
            }}
            onMouseEnter={e => { if (!centerDoorOpen) e.currentTarget.style.filter = 'drop-shadow(0 0 18px rgba(90,180,232,0.7))'; }}
            onMouseLeave={e => e.currentTarget.style.filter = 'none'}
          >
            {/* Fond de la salle mini-portes visible quand la porte s'ouvre */}
            <div style={{
              position:'absolute', inset:0, background:'#07031a', zIndex:0,
            }} />
            <svg viewBox="0 0 160 420" fill="none" width="100%" height="100%" preserveAspectRatio="none"
              style={{ position:'absolute', inset:0, pointerEvents:'none', zIndex:1 }}>
              <rect x="1" y="1" width="158" height="418" stroke="#c47fd4" strokeWidth="1.5" opacity="0.8"/>
              <rect x="12" y="18" width="136" height="384" stroke="#c47fd4" strokeWidth="0.6" opacity="0.35"/>
              <line x1="1" y1="18" x2="159" y2="18" stroke="#c47fd4" strokeWidth="1.2" opacity="0.7"/>
              <line x1="1" y1="419" x2="159" y2="419" stroke="#c47fd4" strokeWidth="2" opacity="0.8"/>
              <circle cx="80" cy="90" r="2.5" fill="#c47fd4" opacity="0.6"/>
              <line x1="14" y1="20" x2="80" y2="90" stroke="#c47fd4" strokeWidth="0.5" opacity="0.3"/>
              <line x1="146" y1="20" x2="80" y2="90" stroke="#c47fd4" strokeWidth="0.5" opacity="0.3"/>
              <line x1="14" y1="398" x2="80" y2="90" stroke="#c47fd4" strokeWidth="0.5" opacity="0.3"/>
              <line x1="146" y1="398" x2="80" y2="90" stroke="#c47fd4" strokeWidth="0.5" opacity="0.3"/>
            </svg>
            {/* Battant avec animation d'ouverture */}
            <div style={{
              position:'absolute', top:'4%', left:'7.5%', width:'85%', height:'92%',
              background:'linear-gradient(135deg, rgba(2,1,8,0.99), rgba(1,0,5,1))',
              transformOrigin: 'left center',
              transform: centerDoorOpen ? 'perspective(600px) rotateY(-110deg)' : 'none',
              transition: 'transform 1.4s cubic-bezier(0.76, 0, 0.24, 1)',
              pointerEvents:'none',
            }}>
              <div style={{
                position:'absolute', right:'11%', top:'50%', transform:'translateY(-50%)',
                width:'6%', height:'8%', background:'rgba(90,180,232,0.25)',
                border:'0.5px solid rgba(90,180,232,0.4)', borderRadius:'1px',
              }}/>
            </div>
          </div>
        </div>
      )}

      {/* ── Salle 4 : mini-portes ── */}
      {activeDoor?.id === 4 && room4Stage === 1 && (
        <div className="qp-room4-doors" style={{ opacity: room4Transition ? 0 : 1, transition: 'opacity 0.7s ease', animation: !room4Transition ? 'qp-room4-fadein 0.7s ease forwards' : 'none' }}>
          {MINI_DOORS_DATA.map((d, i) => (
            <MiniDoor
              key={i} index={i} {...d}
              isOpen={openMiniDoors.has(i)}
              onClick={() => setOpenMiniDoors(prev => {
                const next = new Set(prev);
                if (next.has(i)) { next.delete(i); stopMiniDoorAudio(i); }
                else { next.add(i); startMiniDoorAudio(i); }
                return next;
              })}
            />
          ))}
        </div>
      )}

      {/* ── Texte générique intro — salle 1 ── */}
      {activeDoor?.id === 1 && (
        <div className={`qp-intro${introVisible ? ' qp-intro--visible' : ''}`} onClick={advanceIntro} style={{ cursor: introVisible ? 'pointer' : 'default' }}>
          <div className="qp-intro__text">
            <p style={{
              opacity: introStep >= 1 ? 1 : 0,
              transition: 'opacity 1.8s ease',
            }} className="qp-intro__line">
              Il y a peu de temps, la communauté scientifique a commencé à observer des créatures présentant des mutations biologiques variées. 
            </p>
            <p style={{
              opacity: introStep >= 2 ? 1 : 0,
              transition: 'opacity 1.8s ease',
            }} className="qp-intro__line">
              C’est l’avènement d’une population de chimères.
            </p>
            <p style={{
              opacity: introStep >= 3 ? 1 : 0,
              transition: 'opacity 1.8s ease',
            }} className="qp-intro__line">
              Ces chimères apparaissent aléatoirement dans le monde. Elles possèdent des capacités singulières hybrides de la faune et de la flore terrestre, aquatique et aérienne. 
            </p>
            <p style={{
              opacity: introStep >= 4 ? 1 : 0,
              transition: 'opacity 1.8s ease',
            }} className="qp-intro__line">
              Il semblerait que ces mutations soient causées par l’éveil d’une entité mystique sur Terre…
            </p>
          </div>
        </div>
      )}

      {/* ── Panneau spécimen — salle 1 ── */}
      {activeDoor?.id === 1 && cassetteReady && (
        <div className="qp-specimen">
          <p className="qp-specimen__title">Specimen n°1</p>
          <button
            className="qp-specimen__toggle"
            onClick={() => setSpecimenOpen(o => !o)}
          >
            <span>CARACTÉRISTIQUES OBSERVÉES</span>
            <span className="qp-specimen__arrow">{specimenOpen ? '▲' : '▼'}</span>
          </button>
          <div className={`qp-specimen__panel${specimenOpen ? ' qp-specimen__panel--open' : ''}`}>
            <p><strong><br></br>IDENTIFICATION</strong></p>
            <p><strong>Classification :</strong> bovin suidé féliforme</p>
            <p><strong>Statut :</strong> nouvelle espèce / inconnu</p>
            <p><strong><br></br>ORIGINE ET HABITAT</strong></p>
            <p><strong>Zone géographique :</strong> aperçu au Parc National Alberto de Agostini, au Lac Kivu et les Îles Manus</p>
            <p><strong>Type d'environnement :</strong> zones littorales</p>
            <p><strong>Conditions climatiques :</strong> variées (tropicales à polaires)</p>
            <p><strong><br></br>MORPHOLOGIE</strong></p>
            <p><strong>Taille :</strong> 100cm-150cm de long, 60cm-100cm au garrot</p>
            <p><strong>Masse estimée :</strong> 100kg-150kg</p>
            <p><strong>Nombre de membres :</strong> quadrupède</p>
            <p><strong>Texture de surface :</strong> fourrure courte</p>
            <p><strong>Couleur(s) dominante(s) :</strong> blond/moutarde, diverses couleurs vives au niveau de la tête et des pattes</p>
            <p><strong>Particularités physiques :</strong> muqueuses apparentes sur les flancs, trois paires de cornes et défenses</p>
          </div>
        </div>
      )}

      {/* ── Cassette vintage — salle 1 uniquement ── */}
      {activeDoor?.id === 1 && !introVisible && introStep > 0 && (
        <div className={`qp-cassette${cassetteReady ? ' qp-cassette--visible' : ''}`}>
          <svg
            className="qp-cassette__svg"
            viewBox="0 0 220 140"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            {/* Corps de la cassette */}
            <rect x="4" y="4" width="212" height="132" rx="10" ry="10"
              fill="#1a1730" stroke="rgba(255,255,255,0.15)" strokeWidth="1"/>
            {/* Fenêtre centrale */}
            <rect x="30" y="18" width="160" height="72" rx="6"
              fill="#0a0818" stroke="rgba(255,255,255,0.08)" strokeWidth="0.8"/>
            {/* Ruban */}
            <path d="M 72 54 Q 110 70 148 54" stroke="rgba(180,160,120,0.5)" strokeWidth="1.5" fill="none"/>
            {/* Bobine gauche */}
            <circle cx="72" cy="50" r="22" fill="#111028" stroke="rgba(255,255,255,0.12)" strokeWidth="0.8"/>
            <circle cx="72" cy="50" r="14" fill="#1a1740" stroke="rgba(255,255,255,0.08)" strokeWidth="0.5"/>
            <circle cx="72" cy="50" r="5" fill="#0a0818" stroke="rgba(255,255,255,0.2)" strokeWidth="0.8"/>
            {/* Rayons bobine gauche — animés */}
            <g className="qp-cassette__reel qp-cassette__reel--left">
              <line x1="72" y1="36" x2="72" y2="44" stroke="rgba(255,255,255,0.2)" strokeWidth="1.2"/>
              <line x1="82" y1="39" x2="77" y2="46" stroke="rgba(255,255,255,0.2)" strokeWidth="1.2"/>
              <line x1="86" y1="50" x2="78" y2="50" stroke="rgba(255,255,255,0.2)" strokeWidth="1.2"/>
              <line x1="82" y1="61" x2="77" y2="54" stroke="rgba(255,255,255,0.2)" strokeWidth="1.2"/>
              <line x1="72" y1="64" x2="72" y2="56" stroke="rgba(255,255,255,0.2)" strokeWidth="1.2"/>
              <line x1="62" y1="61" x2="67" y2="54" stroke="rgba(255,255,255,0.2)" strokeWidth="1.2"/>
              <line x1="58" y1="50" x2="66" y2="50" stroke="rgba(255,255,255,0.2)" strokeWidth="1.2"/>
              <line x1="62" y1="39" x2="67" y2="46" stroke="rgba(255,255,255,0.2)" strokeWidth="1.2"/>
            </g>
            {/* Bobine droite */}
            <circle cx="148" cy="50" r="22" fill="#111028" stroke="rgba(255,255,255,0.12)" strokeWidth="0.8"/>
            <circle cx="148" cy="50" r="14" fill="#1a1740" stroke="rgba(255,255,255,0.08)" strokeWidth="0.5"/>
            <circle cx="148" cy="50" r="5" fill="#0a0818" stroke="rgba(255,255,255,0.2)" strokeWidth="0.8"/>
            {/* Rayons bobine droite — animés */}
            <g className="qp-cassette__reel qp-cassette__reel--right">
              <line x1="148" y1="36" x2="148" y2="44" stroke="rgba(255,255,255,0.2)" strokeWidth="1.2"/>
              <line x1="158" y1="39" x2="153" y2="46" stroke="rgba(255,255,255,0.2)" strokeWidth="1.2"/>
              <line x1="162" y1="50" x2="154" y2="50" stroke="rgba(255,255,255,0.2)" strokeWidth="1.2"/>
              <line x1="158" y1="61" x2="153" y2="54" stroke="rgba(255,255,255,0.2)" strokeWidth="1.2"/>
              <line x1="148" y1="64" x2="148" y2="56" stroke="rgba(255,255,255,0.2)" strokeWidth="1.2"/>
              <line x1="138" y1="61" x2="143" y2="54" stroke="rgba(255,255,255,0.2)" strokeWidth="1.2"/>
              <line x1="134" y1="50" x2="142" y2="50" stroke="rgba(255,255,255,0.2)" strokeWidth="1.2"/>
              <line x1="138" y1="39" x2="143" y2="46" stroke="rgba(255,255,255,0.2)" strokeWidth="1.2"/>
            </g>
            {/* Encoche bas gauche */}
            <rect x="14" y="100" width="30" height="28" rx="3" fill="#0e0c22" stroke="rgba(255,255,255,0.07)" strokeWidth="0.5"/>
            {/* Encoche bas droite */}
            <rect x="176" y="100" width="30" height="28" rx="3" fill="#0e0c22" stroke="rgba(255,255,255,0.07)" strokeWidth="0.5"/>
            {/* Zone timeline centrale en bas */}
            <rect x="52" y="104" width="116" height="20" rx="4" fill="#0a0818" stroke="rgba(255,255,255,0.06)" strokeWidth="0.5"/>
            {/* Barre de progression */}
            <rect x="56" y="109" width="108" height="5" rx="2.5" fill="rgba(255,255,255,0.12)"/>
            <rect
              x="56" y="109" width="0" height="5" rx="2.5"
              fill="rgba(180,160,255,0.85)"
              className="qp-cassette__progress-bar"
              ref={cassetteBarRef}
            />
            {/* Curseur de lecture */}
            <circle
              cx="56" cy="111.5" r="5"
              fill="rgba(200,185,255,0.95)"
              className="qp-cassette__cursor"
              ref={el => {
                if (el && cassetteBarRef.current) {
                  // positionné par JS via cassetteBarRef
                }
              }}
            />
            {/* Label */}
            <rect x="52" y="78" width="116" height="18" rx="3" fill="#13112a" stroke="rgba(255,255,255,0.06)" strokeWidth="0.5"/>
            <text x="110" y="91" textAnchor="middle"
              fontFamily="'Courier New', monospace" fontSize="8"
              fill="rgba(255,255,255,0.35)" letterSpacing="1">
              ◀ ▐▐ ▶
            </text>
          </svg>

          {/* Timeline cliquable invisible par dessus */}
          <div
            className="qp-cassette__seek"
            onClick={e => {
              const a = audioRef.current;
              if (!a) return;
              const r = e.currentTarget.getBoundingClientRect();
              a.currentTime = ((e.clientX - r.left) / r.width) * (a.duration || 0);
            }}
          />
        </div>
      )}

      {/* ── Popup infos ── */}
      {infosOpen && (
        <div className="qp-infos-overlay" onClick={() => setInfosOpen(false)}>
          <div className="qp-infos-popup" onClick={e => e.stopPropagation()}>
            <button className="qp-infos-close" onClick={() => setInfosOpen(false)}>✕</button>

            <p className="qp-infos-category">Atelier de pratiques amateurs&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp;&nbsp;16 - 26 ans</p>
            <h2 className="qp-infos-title">&nbsp;&nbsp;Fiction &amp; Mondes multiples</h2>
            <p className="qp-infos-subtitle"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;&nbsp;— s'abreuver à l'open source</p>

            <div className="qp-infos-block qp-infos-block--tight">
              <p>Atelier mené par l'artiste chercheure et compositrice Elise Voët, enseignante à l'ESAD Orléans en installation multimédia  &nbsp; &nbsp; &nbsp; →&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="qp-infos-link">https://elisevoet.space/</span> &nbsp; @_elise_voet_</p>
            </div>

            <div className="qp-infos-divider" />

            <div className="qp-infos-block">
              <p><span className="qp-infos-couleur">Ce petit vestibule aux étranges et intrigantes portes est la production de fin d'année de notre atelier.</span></p>
              <ul className="qp-infos-list"><span className="qp-infos-couleur">
                <li>Porte 1 – Joséphine</li>
                <li>Porte 2 – Gaspard</li>
                <li>Porte 3 – Léonie</li>
                <li>Porte 4 – Nassim</li>
                <li>Porte secrète – Elise</li></span>
              </ul>
            </div>

            <div className="qp-infos-divider" />

            <div className="qp-infos-block">
              <p><strong>F.M.M. c'est la réunion d'une pratique transdisciplinaire des arts numériques, de l'audiovisuel et d'une volonté de créer de façon débridée des fragments de fiction.</strong></p>
              <p>L'année s'articule en petits ateliers (art génératif, mixage, montage, spatialisation sonore, surréalisme, etc) et la découverte d'un panel d'outils variés. 
              <br></br>Certaines séances explorent des aspects théoriques, techniques et critiques des arts numériques, de l'art contemporain et de la pop-culture. Elles permettent d'ouvrir des discussions critiques sur la création en règle générale et de s'organiser des séances de visionnage, d'écoute.</p>
              <p>Tout en bénéficiant d'une pédagogie professionnalisante et critique, les participant·es sont introduit·es à des pratiques alternatives, artisanales en utilisant des outils accessibles portant les idéaux de la culture numérique libre.</p>
            </div>

            <div className="qp-infos-divider" />

            <div className="qp-infos-block">
              <p>Pour en voir plus, cliquez en haut à droite vers l'Atlas ! 
              <br></br><br></br>Si vous êtes intéressé·es, Elise se fera un plaisir de répondre à vos questions par mail : <span className="qp-infos-link">elise.voet@hotmail.fr</span></p>
            </div>
          </div>
        </div>
      )}

      {/* ── Page Atlas — slide depuis la droite ── */}
      {showAtlas && (
        <div
          className={`qp-atlas-slide${atlasVisible ? ' qp-atlas-slide--in' : ''}`}
          onTransitionEnd={e => { if (!atlasVisible && e.propertyName === 'transform') setShowAtlas(false); }}
        >
          <Atlas onBack={() => {
            setAtlasVisible(false);
          }} />
        </div>
      )}

    </>
  );
};

export default QuatrePortes;